import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode
}) => [{
  path: 'personalInfoDownload/components/VerifyCodeDialog',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_personalinfodownload-components-verifycodedialog-index" */'@/pages/personalInfoDownload/components/VerifyCodeDialog/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'personalInfoDownload/components/VerifyCodeDialog',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'personalInfoDownload/components/VerifyCodeDialog',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'personalinfodownload-components-verifycodedialog-index',
  index: true,
  id: 'personalInfoDownload/components/VerifyCodeDialog',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/components/interestMessageList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-components-interestmessagelist-index" */'@/pages/systemMsgList/components/interestMessageList/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/components/interestMessageList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/components/interestMessageList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-components-interestmessagelist-index',
  index: true,
  id: 'systemMsgList/components/interestMessageList',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/recprder/aiChannelpushRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-aichannelpushrecorder" */'@/pages/systemMsgList/recprder/aiChannelpushRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/aiChannelpushRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/aiChannelpushRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-aichannelpushrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/aiChannelpushRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'systemMsgList/recprder/broadcastMsgsRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-broadcastmsgsrecorder" */'@/pages/systemMsgList/recprder/broadcastMsgsRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/broadcastMsgsRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/broadcastMsgsRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-broadcastmsgsrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/broadcastMsgsRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'systemMsgList/components/ListLoading',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-components-listloading-index" */'@/pages/systemMsgList/components/ListLoading/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/components/ListLoading',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/components/ListLoading',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-components-listloading-index',
  index: true,
  id: 'systemMsgList/components/ListLoading',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/components/messageList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-components-messagelist-index" */'@/pages/systemMsgList/components/messageList/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/components/messageList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/components/messageList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-components-messagelist-index',
  index: true,
  id: 'systemMsgList/components/messageList',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/recprder/fansMsgsRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-fansmsgsrecorder" */'@/pages/systemMsgList/recprder/fansMsgsRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/fansMsgsRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/fansMsgsRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-fansmsgsrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/fansMsgsRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'systemMsgList/recprder/myMsgsRecorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-recprder-mymsgsrecorder" */'@/pages/systemMsgList/recprder/myMsgsRecorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/recprder/myMsgsRecorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/recprder/myMsgsRecorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-recprder-mymsgsrecorder',
  index: undefined,
  id: 'systemMsgList/recprder/myMsgsRecorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'personalInfoDownloadRecord',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_personalinfodownloadrecord-index" */'@/pages/personalInfoDownloadRecord/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'personalInfoDownloadRecord',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'personalInfoDownloadRecord',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'personalinfodownloadrecord-index',
  index: true,
  id: 'personalInfoDownloadRecord',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList/useSystemMsgList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-usesystemmsglist" */'@/pages/systemMsgList/useSystemMsgList');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList/useSystemMsgList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList/useSystemMsgList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-usesystemmsglist',
  index: undefined,
  id: 'systemMsgList/useSystemMsgList',
  exact: true,
  exports: ["default"]
}, {
  path: 'personalInfoDownload',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_personalinfodownload-index" */'@/pages/personalInfoDownload/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'personalInfoDownload',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'personalInfoDownload',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'personalinfodownload-index',
  index: true,
  id: 'personalInfoDownload',
  exact: true,
  exports: ["default"]
}, {
  path: 'publicAgreements',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_publicagreements-index" */'@/pages/publicAgreements/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'publicAgreements',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'publicAgreements',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'publicagreements-index',
  index: true,
  id: 'publicAgreements',
  exact: true,
  exports: ["default"]
}, {
  path: 'privacyCenter/config',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_privacycenter-config" */'@/pages/privacyCenter/config');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'privacyCenter/config',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'privacyCenter/config',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'privacycenter-config',
  index: undefined,
  id: 'privacyCenter/config',
  exact: true,
  exports: ["permissionItems", "personalInfoItems", "userInfoItems"]
}, {
  path: 'accessControl',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_accesscontrol-index" */'@/pages/accessControl/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'accessControl',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'accessControl',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'accesscontrol-index',
  index: true,
  id: 'accessControl',
  exact: true,
  exports: ["default"]
}, {
  path: 'privacyCenter',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_privacycenter-index" */'@/pages/privacyCenter/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'privacyCenter',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'privacyCenter',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'privacycenter-index',
  index: true,
  id: 'privacyCenter',
  exact: true,
  exports: ["default"]
}, {
  path: 'systemMsgList',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_systemmsglist-index" */'@/pages/systemMsgList/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'systemMsgList',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'systemMsgList',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'systemmsglist-index',
  index: true,
  id: 'systemMsgList',
  exact: true,
  exports: ["default"]
}, {
  path: 'controlInfo',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_controlinfo-index" */'@/pages/controlInfo/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'controlInfo',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'controlInfo',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'controlinfo-index',
  index: true,
  id: 'controlInfo',
  exact: true,
  exports: ["default"]
}, {
  path: 'setting/recorder',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_setting-recorder" */'@/pages/setting/recorder');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'setting/recorder',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'setting/recorder',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'setting-recorder',
  index: undefined,
  id: 'setting/recorder',
  exact: true,
  exports: ["default", "recordConfig"]
}, {
  path: 'errorPage',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_errorpage-index" */'@/pages/errorPage/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'errorPage',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'errorPage',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'errorpage-index',
  index: true,
  id: 'errorPage',
  exact: true,
  exports: ["default"]
}, {
  path: 'malllist',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_malllist-index" */'@/pages/malllist/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'malllist',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'malllist',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'malllist-index',
  index: true,
  id: 'malllist',
  exact: true,
  exports: ["default"]
}, {
  path: 'message',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_message-index" */'@/pages/message/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'message',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'message',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'message-index',
  index: true,
  id: 'message',
  exact: true,
  exports: ["default"]
}, {
  path: 'setting',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_setting-index" */'@/pages/setting/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'setting',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'setting',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'setting-index',
  index: true,
  id: 'setting',
  exact: true,
  exports: ["default"]
}, {
  path: 'NavBar',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_navbar-index" */'@/pages/NavBar/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'NavBar',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'NavBar',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'navbar-index',
  index: true,
  id: 'NavBar',
  exact: true,
  exports: ["default", "showSelfNav"]
}, {
  path: 'about',
  async lazy() {
    const componentModule = await import(/* webpackChunkName: "p_about-index" */'@/pages/about/index');
    return {
      ...componentModule,
      Component: () => WrapRouteComponent({
        routeId: 'about',
        isLayout: false,
        routeExports: componentModule
      }),
      loader: createRouteLoader({
        routeId: 'about',
        requestContext,
        renderMode,
        module: componentModule
      })
    };
  },
  errorElement: <RouteErrorComponent />,
  componentName: 'about-index',
  index: true,
  id: 'about',
  exact: true,
  exports: ["default"]
}];
export default createRoutes;